import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { SecuritySettingsDomainSectionFragment } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'
import app, { FlashType } from 'modules/core/store/models/app'

interface Props {
  domain: SecuritySettingsDomainSectionFragment
  onClose: () => void
  onVerify: () => void
}

export const ShowInstructionsModal = ({ domain, onClose, onVerify }: Props) => {
  const TOKEN = 'factorial-domain-verification=' + domain.verificationToken
  const showFlashMessage = (type: FlashType, message: string) => {
    app.setFlash({
      type,
      message,
    })
  }

  return (
    <Modal
      illustration="document-edit"
      title={i18n.t('security_settings.domain.show_instructions.title')}
      onSubmit={() => {}}
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.close')}
          </Button>
          <Button type="primary" onClick={onVerify}>
            {i18n.t('security_settings.domain.show_instructions.verify')}
          </Button>
        </>
      }
    >
      <Box gap={'s16'} width="full">
        <Text size="200" color="grey800">
          1. {i18n.t('security_settings.domain.show_instructions.step_1')}
        </Text>
        <Text size="200" color="grey800">
          2. {i18n.t('security_settings.domain.show_instructions.step_2')}
        </Text>
        <Box gap={'s8'} flexDirection="row" alignItems="center">
          <TextField readonly value={TOKEN} />
          <Box>
            <Button
              type="secondary"
              iconName="duplicate"
              onClick={() => {
                navigator.clipboard.writeText(TOKEN)
                showFlashMessage(
                  'correct',
                  i18n.t('security_settings.domain.show_instructions.copy')
                )
              }}
            />
          </Box>
        </Box>
        <Text size="100" color="grey700">
          {i18n.t('security_settings.domain.show_instructions.note')}
        </Text>
      </Box>
    </Modal>
  )
}
